export default [
    {
        path: '/dossier/traveller/out-of-sync/',
        props: true,
        component: () => import('@/views/Dossier/Traveller/OutOfSync.vue'),
    },

];
